import React from "react";
import { Button } from "reactstrap";
import HKPDrawer from "../../common/Components/HKPDrawer";
import HKPProductSummary, { OPTIONAL_PRODUCT_FIELDS } from "./HKPProductSummary";
import { PickerProduct } from "./productSelection";

export default function HKPProductViewDrawer({ product, onClose }: { product: PickerProduct | null; onClose: () => void }) {
  return <HKPDrawer open={Boolean(product)} mode="view" title="Product details" onClose={onClose}
    footer={<Button className="btn-hastkala-outline" onClick={onClose}>Close Product view</Button>}>
    {product && <HKPProductSummary product={product} fields={["owner", "creator", "color", "stock", ...OPTIONAL_PRODUCT_FIELDS.map(([field]) => field), "createdAt", "updatedAt"]} />}
  </HKPDrawer>;
}
